import { Message } from './Message';
import { useAutoScroll } from '../hooks/useAutoScroll';
import { ChatMessage } from '../types';
import '../styles.css';

interface ChatMessagesProps {
  messages: ChatMessage[];
}

export function ChatMessages({ messages }: ChatMessagesProps) {
  const messagesEndRef = useAutoScroll(messages);

  return (
    <div className="chat-messages">
      {messages.map((msg) => (
        <Message
          key={msg.id}
          text={msg.text}
          sender={msg.sender}
          username={msg.username}
        />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
}
